import { numify } from 'numify';
import { useTranslation } from 'react-i18next';
/////////////////////////////////////////////
import { DiamondImage } from '@/app/shared/components';
import { useCustomSelector } from '@/core/redux/hooks';

export const DiamondsSection = () => {
	/*********************
	// #region Hooks
	**********************/
	const { t } = useTranslation();

	/*********************
	// #region Redux
	**********************/
	const { diamonds } = useCustomSelector((state) => state.counter);

	/*********************
	// #region Template
	**********************/
	return (
		<div className="flex flex-col flex-1  pl-1">
			<p>{t('coins.totalDiamonds')}</p>

			<div className="flex items-center gap-1 mx-auto">
				<DiamondImage classes="w-[14px]" />
				<span className=" flex items-center leading-[16px] text-red-400 font-bold text-[11px]">
					{numify(diamonds)}
				</span>
			</div>
		</div>
	);
};
